export enum Permission {
  ConnectOrdersView = 'connect_orders.view',
  ConnectOrdersModify = 'connect_orders.modify',
  RetailersV4View = 'retailers_v4.view',
}
